// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 
console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'); // Create our number formatter.

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD' // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

}); // Cookies functions

function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}
$(function () {
  // Wrap so we can put a dark background behind these divs on the homepage
  $('.wrap-dark').wrapAll("<div class='dark-bg-gradient' />"); //Change homepage product carousels

  $('.product__carousel .options a').on('click', function () {
    $('.product__carousel .options a').removeClass('active');
    $(this).addClass('active');
    $('.product__carousel .slick-slider').fadeOut();
    var thisCarousel = $(this).attr('data-collection');
    $('.product-carousel .slick-slider[data-collection="' + thisCarousel + '"] .slick-prev').click();
    $('.product__carousel .slick-slider[data-collection="' + thisCarousel + '"]').fadeIn();
  });
  $('.mob_bar').click(function () {
    $(this).toggleClass('active');
    $('.header__nav').toggleClass('active');
  });
  $('.acnav__label').click(function (e) {
    e.preventDefault();
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav__list');

    if (parent.hasClass('is-open')) {
      parent.removeClass('is-open');
    } else {
      parent.addClass('is-open');
    }
  });
  $('.back_to_menu').click(function () {
    $(this).closest('.mob_menu_ul').find('.has-children').removeClass('is-open');
  });
  $('.back_to_menu_inner').click(function () {
    $(this).closest('.mega_menu_wrap').find('.has-children').removeClass('is-open');
  });
  $('.mob_bar').click(function () {
    $('.has-children').removeClass('is-open');
  });
// $(window).on('load resize orientationchange', function () {
//   if (window.matchMedia('(max-width: 767px)').matches) {
    
//   }
// });
  $(".footer_menu h3").click(function (e) {
      e.preventDefault();

      if ($(this).closest('.footer_menu').hasClass('active')) {
        $(".footer_menu").removeClass("active");
        $(".footer_menu ul").slideUp(300);
      } else {
        $(".footer_menu").removeClass("active");
        $(this).closest('.footer_menu').addClass('active');
        $(".footer_menu ul").slideUp(300);
        $(".footer_menu.active ul").slideToggle(300);
      }
    });
});
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault(); // If item clicked on is open, close it

    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  }); // Show / hide address add form

  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  /******************************************
   QTY Selector ( Simple quantity box increase / decrease )
  ******************************************/
  // PDP / PLP
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  }); // MAIN CART

  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    if (qtyInputVal >= 1) {
      console.log('got here');
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }
  }); // MAIN CART REMOVE

  $('.actions .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });
  /******************************************
    Options to change SM-RC Widget dropdowns 
   ******************************************/
  // SELECT TYPE

  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // BUTTON TYPE

  $('.option__wrap button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option'); // Set visual display of active

    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // RECHARE WIDGET VARIANTS

  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  }); // RECHARE WIDGET SUBSCRIPTION PLAN

  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     Header Search
   ******************************************/
  // Show desktop search on click and focus on input
  $('.icon--search').on('click', function (e) {
    e.preventDefault();
    $('.desktop-search').fadeIn('fast', '', function () {
      $('body').addClass('search-open');
      $('.desktop-search input').focus();
    });
  }); // Close desktop search if click outside

  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');

    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      desktopSearch.fadeOut('fast', '', function () {
        $('body').removeClass('search-open');
        $('.icon--search').focus();
      });
    }
  });
  /******************************************
    Mobile Menu
  ******************************************/
  // Trigger mobile menu display

  $('.header__mobile-trigger button').on('click', function () {
    $(this).toggleClass('is-active');
    $('.mobile-menu').fadeToggle('fast', '', function () {
      $('html').toggleClass('mobile-menu-open');
    });
  });
  /******************************************
    Modals
  ******************************************/
  // Launch the modal

  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');

    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }

    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }

    $(modalID).fadeIn('fast');
  }); // Close the modal

  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this));
  });
});

function closeModal(object) {
  object.closest('.modal').fadeOut('fast', function () {
    $('.modal__inner .iframe-wrap').remove();
  });
}
jQuery(document).ready(function ($) {
  // Set alert bar to slider
  $('.alert-bar__slider').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 3500
  }); // Init header offset function

  headerOffset(); // Update offset on scroll

  $(window).on('scroll resize', function () {
    headerOffset();
  });
  
  
  // Update offset on alert bar close

  // $('.alert-bar .close--alert').on('click', function () {
  //   $('.alert-bar').remove();
  //   headerOffset();
  //   if ($('body').hasClass('template__index')) {
  //     $( '#main' ).css( 'padding-top', '0' );
  //   }
  // }); 

    var alertClosed = localStorage.getItem('alertClosed');
  var alertTime = parseInt(localStorage.getItem('alertTime'));
  var currentTime = new Date().getTime();
  var expirationPeriod = 86400000; 

  if (!alertClosed || (currentTime - alertTime >= expirationPeriod)) {
    $('.alert-bar').show();
    if ($('body').hasClass('template__index')) {
      headerOffset();
    }
  }

  if (alertClosed && (currentTime - alertTime < expirationPeriod)) {
    $('.alert-bar').remove(); 
    headerOffset();
    if ($('body').hasClass('template__index')) {
      $( '#main' ).css( 'padding-top', '0' );
    }
  }

  $('.alert-bar .close--alert').on('click', function() {
    $('.alert-bar').remove(); 
    headerOffset(); 
    if ($('body').hasClass('template__index')) {
      $('#main').css('padding-top', '0');
    }
    localStorage.setItem('alertClosed', 'true');
    localStorage.setItem('alertTime', currentTime.toString());
  });
  
  
  // Offset content from fixed header

  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    // $( '#main' ).css( 'padding-top', headerHeight+'px' );

    $('.pdp__images').css('top', headerHeight + 'px');
    $('.mobile-menu__inner, .mini-cart').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();

      if ($(window).scrollTop() >= 40) {
        $('.fixed-wrap').addClass('scrolling');

        if (newsHeight != undefined) {
          $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
        }

        $('.mobile-menu__inner').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
      }
    });

    console.log("header offset");
  }
});
jQuery(document).ready(function ($) {
  // Close mini cart
  $('.mini-cart__bg, .mini-cart__content .close').on('click', function () {
    closeMini();
  }); // Show mini cart

  $('.header .icon--cart').on('click', function (e) {
    e.preventDefault();

    if (!$('body').hasClass('template__cart')) {
      showMini();
    } else {
      e.preventDefault();
    }
  }); // Mini Cart Remove Product

  $('.mini-cart').on('click', '.remove-product', function () {
    var lineNum = $(this).closest('.product').attr('data-lineid');
    $(this).closest('.product').addClass('removed');
    CartJS.removeItem(lineNum, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Upsell ATC

  $('.mini-cart__upsell .action--atc').on('click', function (e) {
    e.preventDefault();
    var dataId = $(this).closest('.upsell').attr('data-id');
    CartJS.addItem(dataId, 1, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  }); // Mini Cart Qty

  $('.mini-cart__list').on('click', '.js-qty--mini', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
    var lineData = $this.closest('.product').data('lineid');
    var lineNum = $('[data-lineID="' + lineData + '"]').index();

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
    }

    CartJS.updateItem(lineNum + 1, qtyInputVal, {}, {
      success: function success(data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          refreshMiniCart(cart);
        });
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(errorThrown);
      }
    });
  });
});

function closeMini() {
  $('body').removeClass('cart-open');
  $('.mini-cart').removeClass('is-open');
  $('.mini-cart').fadeOut('fast');
}

function showMini() {
  $('body').addClass('cart-open');
  $('.mini-cart').fadeIn('fast');
  $('.mini-cart').addClass('is-open'); // Set height of product list for full-height mini-cart
  // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
  // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
  // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
  // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
  // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
}

function refreshMiniCart(cartData) {
  var cartItems = cartData.items;
  var newCartHtml = ''; // Free shipping updater

  var totalShip = parseInt($('.mini-cart').data('freeship'));
  var newCartTotal = cartData.items_subtotal_price;
  var awayShip = totalShip - newCartTotal;
  var shipPercent = newCartTotal / totalShip * 100;

  if (shipPercent >= 100) {
    $('.shipping-bar--progress').css('width', '100%');
    $('.mini-cart__ship').addClass('is-free');
  } else {
    if ($('.mini-cart__ship').hasClass('is-free')) {
      $('.mini-cart__ship').removeClass('is-free');
    }

    $('.free-count').text(formatter.format(awayShip / 100));
    $('.shipping-bar--progress').css('width', shipPercent + '%');
  } // Build html of new products in cart


  $.each(cartItems, function (index, item) {
    // Opening
    newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
    newCartHtml += ' <div class="product__image">';

    if (item.featured_image) {
      newCartHtml += '<a href="' + item.url + '">';
      newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
      newCartHtml += '</a>';
    }

    newCartHtml += '</div>';
    newCartHtml += '<div class="product__info">';
    newCartHtml += '<div class="title d-flex">';
    newCartHtml += '<h3 class="heading--four d-flex justify-between">';
    newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
    newCartHtml += item.product_title;
    newCartHtml += '</a>';
    newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
    newCartHtml += '</h3>';

    if (item.variant_options != null) {
      newCartHtml += '<span class="var">';
      $.each(item.variant_options, function (index, value) {
        if (value != 'Default Title') {
          if (index != 0) {
            newCartHtml += ' / ';
          }

          newCartHtml += value;
        }
      });
      newCartHtml += '</span>';
    }

    if (item.hasOwnProperty('selling_plan_allocation')) {
      newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
    }

    newCartHtml += '<span class="unit-price">' + formatter.format(item.price / 100) + '</span>';
    newCartHtml += '</div>'; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

    newCartHtml += "<div class=\"actions d-flex align-center justify-between\">\n          <div class=\"action action--qty\">\n            <div class=\"qty d-flex align-center\">\n              <button class=\"js-qty js-qty--mini js-qty--minus trans\">\n                <span class=\"sr-only\">Decrease</span>\n              </button>\n              <input sm-rc-quantity-selector type=\"text\" value=\"" + item.quantity + "\" min=\"1\"  type=\"number\" class=\"qty-val\" />\n              <button class=\"js-qty js-qty--mini js-qty--plus trans\">\n                <span class=\"sr-only\">Increase</span>\n              </button>\n            </div>\n          </div>";
    newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>';
    newCartHtml += '</div>'; // Closing

    newCartHtml += '</div>';
    newCartHtml += '</div>';
  }); // Clear current products in cart

  $('.mini-cart__items').empty(); // Set new subtotal

  $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100)); // Set new header icon count

  $('.icon--cart .cart-count span ').text(cartData.item_count); // Add updated producst to mini cart

  $('.mini-cart__list').html(newCartHtml); // Show mini cart

  showMini();
}
// ----------------------------------- custom scripts -------------------------------------------

